import React from 'react';
import { Phone, Smartphone } from 'lucide-react';
import { trackCallConversion } from '../../utils/tracking';
import './CtaBanner.css';

const CtaBanner = () => {
  const handleOpenBooking = (serviceName = "Emergency iPhone Repair") => {
    const bookingEl = document.getElementById("booking");
    if (bookingEl) {
      bookingEl.scrollIntoView({ behavior: "smooth" });
    } else {
      window.location.href = "/#booking";
    }
  };

  return (
    <section className="iphone-cta-banner">
      <div className="iphone-container iphone-cta-inner">
        <div className="cta-text-block">
          <h2>iPhone Broken? Get It Fixed Today at Your Door.</h2>
          <p>Our certified technicians are available across Delhi NCR. 30-60 min arrival. Upfront fixed pricing.</p>
        </div>
        <div className="cta-btn-group">
          <a
            href="tel:+918700319769"
            className="cta-call-iphone-btn"
            data-dsmr-phone="true"
            onClick={(e) => trackCallConversion(e, "tel:+918700319769")}
          >
            <Phone size={18} />
            <span>Call +91 8700319769</span>
          </a>
          <button className="cta-book-iphone-btn" onClick={() => handleOpenBooking("Emergency iPhone Repair")}>
            <Smartphone size={18} />
            <span>Book Repair Now</span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default CtaBanner;
